export enum RpServiceAttributePropertyTypes {
    USER_VISIBLE_FLAG = "userVisibleFlag",
    OPTIONAL_FLAG = "optionalFlag",
    USER_EDITABLE_FLAG = "userEditableFlag",
    PLACEHOLDER_FLAG = "placeholderFlag",
    AUTOSUBMIT_FLAG = "autoSubmitFlag",
    IS_ASYNC = "isAsync",
    IGNORE_PDS_DATA = "ignorePDSData",
    DO_NOT_SAVE_TO_PDS = "doNotSaveToPDS",
    CUSTOM_TOOLTIP = "customToolTip",
    REQUIRED_FOR_SELF_SERVICE_VERIFICATION = "requiredForSelfServiceVerification",
    DISPLAY_FULL_VALUE = "displayFullValue"
}